import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stateName: "",
  cityName: "",
  cityId: "",
  lat: 23.0225,
  lng: 72.5714,
  isLocation: false,
};

export const locationSlice = createSlice({
  name: "locationSlice",
  initialState,

  reducers: {
    setUserLocation: (state, action) => {
      state.stateName = action.payload.stateName;
      state.cityName = action.payload.cityName;
      state.stateId = action.payload.stateId;
      state.cityId = action.payload.cityId;
      state.lat = action.payload.lat;
      state.lng = action.payload.lng;
      state.isLocation = action.payload.isLocation;
      state.openLocationModal = action.payload.openLocationModal;
    },
  },
});
export const { setUserLocation } = locationSlice.actions;
export default locationSlice.reducer;
